import { FC, SyntheticEvent } from 'react';
import { Box, BoxProps, Skeleton, Text } from '@chakra-ui/react';
export interface CbCategoryCardProps extends Partial<Omit<BoxProps, 'id'>> {
  id: number;
  imageUrl?: string | null;
  isPending: boolean;
  name?: string;
  onCardClick?: (id: number) => void;
}
export const CbCategoryCard: FC<CbCategoryCardProps> = ({
  id,
  imageUrl,
  isPending,
  name,
  onCardClick,
  ...props
}) => {
  const handleCardClick = (event: SyntheticEvent) => {
    onCardClick && onCardClick(id);
  };
  return <Box data-testid="category-card" backgroundImage={isPending ? undefined : `url("${imageUrl}")`} backgroundSize="cover" backgroundPosition="center" borderRadius={12} overflow="hidden" onClick={handleCardClick} {...props} data-sentry-element="Box" data-sentry-component="CbCategoryCard" data-sentry-source-file="CbCategoryCard.tsx">
      <Box paddingBottom="63%" position="relative" data-sentry-element="Box" data-sentry-source-file="CbCategoryCard.tsx">
        {isPending ? <Skeleton data-testid="skeleton" position="absolute" top="0" left="0" height="100%" width="100%" /> : <>
            <Box backgroundColor={imageUrl ? 'luigisPants.500' : undefined} background={!imageUrl ? 'gradient.blue' : undefined} borderRadius={12} position="absolute" top="0" left="0" height="100%" width="100%" opacity={imageUrl ? '0.6' : '1'} overflow="hidden" />
            <Text pointerEvents="none" position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" color="white" fontSize={{
          base: 'xl',
          sm: '2xl'
        }} fontWeight="bold" textAlign="center" width="90%">
              {name}
            </Text>
          </>}
      </Box>
    </Box>;
};